<template>
  <ValidationProvider
    v-slot="{ errors, valid }"
    :name="label"
    :rules="rules"
    :vid="vid"
  >
    <BaseField
      :label="label"
      :label-for="$attrs.id"
      :type="{ 'is-danger': errors[0], '': valid }"
      :message="errors && errors.length > 0 ? errors : message"
    >
      <template #label>
        <slot name="label" />
      </template>
      <b-input
        v-model="currentValue"
        v-bind="$attrs"
        size="is-small"
        custom-class="f-input"
      ></b-input>
    </BaseField>
  </ValidationProvider>
</template>

<script>
import BaseField from './BaseField'
import BaseFieldMixin from './BaseFieldMixin'

export default {
  components: {
    BaseField,
  },
  mixins: [BaseFieldMixin],
  inheritAttrs: false,
}
</script>
